import { Target, ShieldCheck, Wrench } from "lucide-react";

export default function WhyBlackline() {
  return (
    <section
      id="credibility"
      className="py-16 md:py-24 border-t-4 border-black bg-black text-white"
      data-testid="credibility-section">

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="mb-12 md:mb-16">
          <span className="font-mono text-sm uppercase tracking-widest text-zinc-500">
            04 — Why Us
          </span>
          <h2
            className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl uppercase mt-4"
            data-testid="credibility-title">

            Why BLACKLINE
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 md:gap-16">
          {/* Left: Punchy message */}
          <div>
            <p className="font-heading font-bold text-2xl md:text-3xl uppercase leading-tight mb-6 text-white">
              Two decades in the field. Now we do the numbers.
            </p>
            <p className="font-body text-zinc-400 leading-relaxed mb-6">
              We've run sites, managed programmes, and dealt with the surprises that never make it onto the drawings. Civil infrastructure, residential builds, the jobs where getting it wrong costs real money.
            </p>
            <p className="font-body text-zinc-400 leading-relaxed">
              That experience goes into every estimate. We know where jobs blow out, and we price for reality, not hope.
            </p>
          </div>

          {/* Right: Value props */}
          <div className="flex flex-col justify-center">
            <div className="border-l-4 border-white pl-6 md:pl-8 mb-8">
              <blockquote
                className="font-heading font-bold text-xl md:text-2xl uppercase leading-tight"
                data-testid="credibility-quote">

                No fluff. No mystery scope. No pricing by hope.
              </blockquote>
            </div>

            {/* Value props */}
            <div className="space-y-4">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 border border-zinc-700 flex items-center justify-center flex-shrink-0">
                  <Target size={20} strokeWidth={1.5} className="text-zinc-400" />
                </div>
                <span className="font-body text-zinc-300">Trade-based BOQs with clear assumptions</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 border border-zinc-700 flex items-center justify-center flex-shrink-0">
                  <Wrench size={20} strokeWidth={1.5} className="text-zinc-400" />
                </div>
                <span className="font-body text-zinc-300">Realistic labour allowances that hold up</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 border border-zinc-700 flex items-center justify-center flex-shrink-0">
                  <ShieldCheck size={20} strokeWidth={1.5} className="text-zinc-400" />
                </div>
                <span className="font-body text-zinc-300">Scope boundaries that protect your margin</span>
              </div>
            </div>
          </div>
        </div>

        {/* Background image */}
        <div className="mt-16 border-4 border-zinc-800 overflow-hidden hidden md:block">
          <img
            src="https://customer-assets.emergentagent.com/job_builder-estimates/artifacts/8hafomek_IMG_3491%20%281%29.jpeg"
            alt="Timber framing construction"
            className="w-full h-48 md:h-64 object-cover grayscale opacity-60" />

        </div>
      </div>
    </section>);

}